import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Modal, message } from 'antd';
import SingleHeader from './SingleHeader';
import DoubleHeader from './DoubleHeader';
import fp from '../../../utils/fp';
import hyphenToCamelCase from '../../shared/hyphenToCamelCase';
import API_URL from '../../../common/url';
import Fetch from '../../../common/Fetch';
import dictCache from '../../../common/dictCache';
import { queryApprovalUserCachedAsync } from '../../../common/permissionCache';
import { LookAttachment, OperationLog, ApplyAdjustment,
    ApplyHistory, RegisterMilestoneDate, RegisterRequestDate } from './components/PreviewModal';
import UpdateReturnedProgress from './components/UpdateReturnedProgress';
import AdjustPayUnit from './components/AdjustPayUnit';
import InformRequest from './components/InformRequest';
import MatchReturned from './components/MatchReturned';
import ConfigColumn from './components/ConfigColumn';
import ExportModal from './components/ExportModal';
import Attachment from './components/Attachment';
import SortList from './components/SortList';
import FoldSet from './components/FoldSet';
import Update from './components/Update';
import Filter from './components/Filter';
import ProjectSideNav from '../../projectContract/SideNav';
import UserDetail from '../../investigation/UserDetail';
import SideNav from '../SideNav';
import '../style.less';
import { saveParams } from '../../../actions/noticeActions';

const defaultSearchParams = {
    jdeContractAmountSymbol: 'Equals',
    startTimeSymbol: 'Equals',
    endTimeSymbol: 'Equals',
};

class RequestRecord extends Component {
    state = {
        loading: false,
        searchParams: {...defaultSearchParams},
        sortParams: {},
        pagination: {
            pageSize: 10,
            current: 1,
        },
        listCollection: {},
        approval: {},
        businessList: [],
        contractTypeList: [],
        dateModifyReason: [],
        returnedProgressList: [],
        areaOptions:[],
        diseaseOptions:[],
        systemDate: null,
        loadData: null,
        loadHead: null,
        headerType: undefined,
        isAdd: false,
    }

    componentDidMount() {
        this.autoAdd();
        this.acceptSearchParams();
        this.queryEffectiveDate();
        this.queryApprovalUser();
        this.loadAreaList();
        ['Contract_Nature', 'Expense_Type', 'Invoice_Type', 'Payment_Progress'].forEach(i =>
            this.queryContractRemittanceDictByType(i)
        );
        const { invId, invState } = sessionStorage;
        if (invState == 1) {
            this.setState({ headerType: 'SINGLE' });
            this.queryInvestigationStageByInvId(invId);
        } else {
            this.queryUserTitleShow();
        }
        this.queryByParams();
        this.loadTypeConfigureList();
        this.queryWithLevelByParams();
    }

    loadHead = () => {
        this.setState({ loadHead: {} });
    }

    loadData = () => {
        this.setState({ loadData: {} });
    }

    autoAdd = () => {
        const { params } = this.props;
        const { autoAdd, cashReqNode, contractRemittanceNodeId, investigationJdeContractId, investigationId, investigationName } = params;
        if (autoAdd === true) {
            this.updateRef.show({investigationId, investigationName , investigationJdeContractId , invoiceTypeId: null, fteRate: null, cashReqNode: contractRemittanceNodeId, remittanceNodeId: contractRemittanceNodeId }, 'autoAdd');
        }

    }

    acceptSearchParams = () => {
        const { params } = this.props;
        const { searchParams } = this.state;
        const { remittanceCode, investigationName, investigationJdeContractCode, paymentProgressIds } = params;
        if (remittanceCode || investigationName || investigationJdeContractCode) {
            searchParams.remittanceCode = remittanceCode;
            searchParams.investigationName = investigationName;
            searchParams.investigationJdeCode = investigationJdeContractCode;
            searchParams.paymentProgressIds = paymentProgressIds ? paymentProgressIds.split(',') : undefined;
        }
        this.setState({ searchParams }, () => {
            this.loadData();
        });
    }
    
    componentWillUnmount() {
        this.props.saveParams({
            remittanceCode: '',
            investigationId: '',
            investigationName: '',
            investigationJdeContractId: '',
            investigationJdeContractCode: '',
            paymentProgressIds: '',
            autoAdd: undefined
        });
    }

    queryUserTitleShow = () => {
        this.setState({ loading: true });
        Fetch.post(API_URL.contract.queryUserTitleShow, {
            type: 'CONTRACT_REMITTANCE_APPLICATION'
        }).then(res => {
            const { showType } = res;
            this.setState({
                loading: false,
                headerType: showType,
                pagination: {
                    pageSize: showType === 'SINGLE' ? 10 : 1,
                    current: 1,
                }
            });
        });
    }

    delete = (record) => {
        Modal.confirm({
            iconType: 'question-circle',
            title: "确定删除该条请款记录？",
            onOk: () => {
                const {
                    investigationJdeContractId,
                    contractRemittanceApplicationId,
                } = record;
                this.changeLoading(true);
                Fetch.post(API_URL.contract.delContractRemittanceApplication, {
                    investigationJdeContractId,
                    contractRemittanceApplicationId,
                }).then(res => {
                    message.success(res.success);
                    this.changeLoading(false);
                    this.loadData();
                }).catch(error => {
                    console.error(error);
                    this.changeLoading(false);
                });
            },
        });
    }

    recallInformRequest = record => {
        Modal.confirm({
            iconType: 'question-circle',
            title: "确定撤回该条通知请款？",
            onOk: () => {
                const {
                    contractRemittanceApplicationId,
                } = record;
                this.changeLoading(true);
                Fetch.post(API_URL.contract.recallNoticeContractRemittanceApplication, {
                    contractRemittanceApplicationId,
                }).then(res => {
                    message.success(res.success);
                    this.changeLoading(false);
                    this.loadData();
                }).catch(error => {
                    console.error(error);
                    this.changeLoading(false);
                });
            },
        });
    }

    queryEffectiveDate = () => {
        dictCache.getDict('EFFECTIVE_DATE', cb => {
            Fetch.post(API_URL.home.queryEffectiveDate).then(cb);
        }, res => {
            const { date } = res;
            this.setState({ systemDate: date });
        });
    }

    loadAreaList = () => {
        dictCache.getDict('AREA_ALL', cb => {
            Fetch.post(API_URL.common.queryAllInvestigationArea, {}).then(cb).catch(error => {
                console.error(error);
            });
        }, res => {
            const areaOptions = (res.data || []).map(item => {
                const { investigationAreaId, investigationAreaName } = item;
                return {
                    label: investigationAreaName,
                    value: investigationAreaId,
                };
            });
            this.setState({ areaOptions });
        });
    }

    loadDiseaseList = investigationAreaId => {
        if (!investigationAreaId) return;
        Fetch.post(API_URL.common.queryAllDisease, {
            investigationAreaId
        }).then(res => {
            const diseaseOptions = (res.data || []).map(item => {
                const { diseaseId, diseaseName } = item;
                return {
                    value: diseaseId,
                    label: diseaseName,
                };
            });
            this.setState({ diseaseOptions });
        }).catch(error => {
            console.error(error);
        });
    }

    queryApprovalUser = () => {
        this.setState({ loading: true });
        queryApprovalUserCachedAsync('BAL_DEFAULT_APPROVER,REMITTANCE_CUSTOMER_APPLY_USER')
        .then(res => {
            this.setState({
                loading: false,
                approval: res,
            });
        }).catch(error => {
            console.error(error);
            this.setState({ loading: false });
        });
    }

    queryWithLevelByParams = () => {
        dictCache.getDict('LINE_OF_BUSINESS', cb => {
            Fetch.post(API_URL.common.queryWithLevelByParams, {
                typeName: 'LINE_OF_BUSINESS'
            }).then(cb).catch(error => {
                console.error(error);
            });
        }, res => {
            this.setState({ businessList: res.typeConfigureList || [] });
        });
    }

    queryContractRemittanceDictByType = (dictType) => {
        dictCache.getDict(`REMITTANCE_DICT_${dictType}`, cb => {
            Fetch.post(API_URL.contract.queryContractRemittanceDictByType, {
                dictType,
            }).then(cb).catch(error => {
                console.error(error);
            });
        }, res => {
            const { listCollection } = this.state;
            const { data = [] } = res;
            listCollection[hyphenToCamelCase(dictType)] = data;
            this.setState({ listCollection });
        });
    }

    queryByParams = () => {
        Fetch.post(API_URL.investigation.queryByParams, {
            typeName: 'REMITTANCE_BACK_PROGRESS'
        }).then(res => {
            this.setState({ returnedProgressList: res.typeConfigureList || [] });
        }).catch(error => {
            console.error(error);
        });
    }

    loadTypeConfigureList = () => {
        dictCache.getDict('TYPE_CONFIGURE', cb => {
            Fetch.post(API_URL.common.typeConfigureList)
                .then(cb)
                .catch(error => {
                    console.error(error);
                });
        }, res => {
            const { contractTypeList, dateModifyReason } = res;
            this.setState({
                contractTypeList,
                dateModifyReason,
            });
        });
    }

    queryInvestigationStageByInvId = (investigationId, callback) => {
        this.setState({ loading: true });
        Fetch.post(API_URL.investigation.queryInvestigationStageByInvId, {
            investigationId,
        }).then(res => {
            const { data } = res;
            this.setState({
                loading: false,
                invStageList: data,
            }, () => {
                callback && this.canEditByInvStatus(callback);
            });
        }).catch(error => {
            console.error(error);
            this.setState({ loading: false });
        });
    }

    canEditByInvStatus = (callback) => {
        const { invStageList: data = [] } = this.state;
        const canEdit = !(data || []).some(i => {
            if (i.operation === 'INVESTIGATION_DATA_LOCK') {
                message.error('项目到达“项目关闭”阶段，不可调整项目相关数据！');
                return true;
            } else if(i.operation === 'TERMINATED_BEFORE_CONTRACT'){
                message.error('项目已在服务合同签署前终止，不可调整项目相关数据');
                return true;
            }
            return false;
        });
        if (callback.handleError) {
            callback(canEdit);
            return;
        }
        if (canEdit) {
            callback();
        }
    }

    handleFilterChange = (searchParams) => {
        this.setState({ searchParams: { ...searchParams } });
    }

    handleTableChange = (params, loadData) => {
        this.setState({...params}, () => {
            loadData && this.loadData();
        });
    }

    search = () => {
        const { pagination } = this.state;
        pagination.current = 1;
        this.setState({ pagination }, () => {
            this.loadData();
        });
    }

    export = () => {
        this.exportRef.show();
    }

    changeLoading = (loading) => {
        this.setState({ loading });
    }

    resolveUserList = (list, role, linefeed = true) => {
        const len = list ? list.length : 0;
        return (
            <span>
                {
                    (list || []).map((item, index) => {
                        const { userId, userName, employeeCode, baStatus } = item;
                        const user = role === 'BA' ? userName : `${userName}[${employeeCode}]`;
                        const content = (
                            <span>
                                {user}{index < len - 1 ? '，' : ''}
                                {((index < len - 1) && linefeed) ? <br /> : ''}
                            </span>
                        );
                        return (
                            (role === 'BA' && !!baStatus) ?
                                <span key={userId} style={{color: '#ccc'}}>
                                    {content}
                                </span>
                            :  
                                <a key={userId} onClick={() => this.showUserInfo(userId)}>
                                    {content}
                                </a>
                        )
                    })
                }
            </span>
        );
    }

    showAttachment = (record, type) => {
        this.lookAttachmentRef.show(record, type);
    }

    uploadAttachment = (record) => {
        this.attachmentRef.show(record, true);
    }

    update = (record, type) => {
        const { remittanceCompletedInfo } = record || {};
        if (type === 'update' && fp.contains(remittanceCompletedInfo)(['Tobe_PM_Confirmed', 'Tobe_FIN_Confirmed', 'FIN_Confirmed'])) {
            message.warning('此合同已进入请款完成申请流程，不可更新请款进度！');
        } else if (type === 'copy' && fp.contains(remittanceCompletedInfo)(['Tobe_PM_Confirmed', 'Tobe_FIN_Confirmed', 'FIN_Confirmed'])) {
            message.warning('此合同已进入请款完成申请流程，不可复制新建请款记录！');
        } else {
            this.updateRef.show(record, type);
        }
    }

    updateReturned = (record) => {
        this.returnedProgressRef.show(record);
    }

    showUserInfo = (userId) => {
        this.userDetailRef.show(userId);
    }

    matchReturned = (record) => {
        this.matchRef.show(record);
    }

    informRequest = (record) => {
        this.informRef.show(record);
    }

    showOperationLog = (record) => {
        this.operationLogRef.show(record);
    }

    adjustPayUnit = (record, type) => {
        this.adjustPayUnitRef.show(record, type);
    }

    applyAdjustment = (record, type) => {
        const { remittanceCompletedInfo } = record || {};
        if (type === 'apply' && fp.contains(remittanceCompletedInfo)(['Tobe_PM_Confirmed', 'Tobe_FIN_Confirmed', 'FIN_Confirmed'])) {
            message.warning('此合同已进入请款完成申请流程，不可申请调整请款！');
        } else {
            this.applyAdjustmentRef.show(record, type);
        }
    }

    applyHistory = (record) => {
        this.applyHistoryRef.show(record);
    }

    registerMilestoneDate = (record) => {
        this.milestoneDateRef.show(record);
    }

    registerRequestDate = (record) => {
        this.requestDateRef.show(record);
    }

    continueAdd = (state) => {
        const { headerType, searchParams, pagination } = this.state
        if (headerType === 'SINGLE') {
            this.loadData();
        } else {
            const { saveParams: { investigationName, investigationJdeContractCode } } = state;
            searchParams.investigationName = investigationName;
            searchParams.investigationJdeCode =investigationJdeContractCode;
            pagination.current = 1;
            this.setState({
                pagination,
                searchParams,
            }, () => {
                this.loadData();
            });
        }
        Modal.confirm({
            iconType: 'question-circle',
            title: "是否继续为该合同登记请款？",
            onOk: () => {
                this.updateRef.acceptState(state);
            }
        });
    }

    configColumn = () => {
        this.configColumnRef.show();
    }

    foldSet = () => {
        this.foldSetRef.show();
    }

    sort = (key) => {
        const { headerType } = this.state;
        let type;
        key === 'contractSort' && 'CASH_REQ_MULTI_CONTRACT' || (headerType === 'SINGLE' && key === 'contractSort' && 'CASH_REQ_MULTI_CONTRACT')
        if (key === 'contractSort') {
            type = 'CASH_REQ_MULTI_CONTRACT';
        } else if (headerType === 'SINGLE' && key === 'requestSort') {
            type = 'CASH_REQ';
        } else {
            type = 'CASH_REQ_MULTI_APPLICATION';
        }
        this.sortListRef.show(type);
    }

    toggleHeader = () => {
        const { headerType } = this.state;
        const nextHeaderType = headerType === 'SINGLE' ? 'MULTIPLY' : 'SINGLE';

        this.setState({ loading: true });
        Fetch.post(API_URL.contract.queryUserTitleShow, {
            showType: nextHeaderType,
            type: 'CONTRACT_REMITTANCE_APPLICATION'
        }).then(res => {
            const { showType } = res;

            let pagination = { current: 1 };
            if (nextHeaderType === 'SINGLE') {
                pagination.pageSize = 10;
            } else {
                pagination.pageSize = 1;
            }
            this.setState({
                pagination,
                sortParams: {},
                loading: false,
                headerType: showType,
            });
        });
    }

    changeAddable = (isAdd) => {
        this.setState({ isAdd });
    }

    render() {
        const { isAdd, searchParams, sortParams, pagination, listCollection,
            contractTypeList, dateModifyReason, businessList, returnedProgressList,
            systemDate, approval, loadHead, loadData, loading, headerType, areaOptions, diseaseOptions } = this.state;
        const hash = location.hash.slice(1);
        const Table = headerType === 'SINGLE' ? SingleHeader : DoubleHeader;
        return (
            <div className="content">
                {
                    hash === '/contractManagement/requestRecord' ?
                        <SideNav selectKey='requestRecord' />
                    :
                        <ProjectSideNav selectKey='requestRecord' />
                }
                <div className="main">
                    <Filter
                        isAdd={isAdd}
                        search={this.search}
                        export={this.export}
                        update={this.update}
                        headerType={headerType}
                        areaOptions={areaOptions}
                        diseaseOptions={diseaseOptions}
                        searchParams={searchParams}
                        businessList={businessList}
                        listCollection={listCollection}
                        contractTypeList={contractTypeList}
                        dateModifyReason={dateModifyReason}
                        sort={this.sort}
                        foldSet={this.foldSet}
                        configColumn={this.configColumn}
                        toggleHeader={this.toggleHeader}
                        onChange={this.handleFilterChange}
                        loadDiseaseList={this.loadDiseaseList}
                        canEditByInvStatus={this.canEditByInvStatus}
                    />
                    {
                        headerType &&
                        <Table
                            isAdd={isAdd}
                            loading={loading}
                            loadHead={loadHead}
                            loadData={loadData}
                            approval={approval}
                            searchParams={searchParams}
                            sortParams={sortParams}
                            pagination={pagination}
                            delete={this.delete}
                            onChange={this.handleTableChange}
                            changeAddable={this.changeAddable}
                            changeLoading={this.changeLoading}
                            resolveUserList={this.resolveUserList}
                            checkProjectIsFinish={this.queryInvestigationStageByInvId}
                            showAttachment={this.showAttachment}
                            uploadAttachment={this.uploadAttachment}
                            update={this.update}
                            updateReturned={this.updateReturned}
                            matchReturned={this.matchReturned}
                            informRequest={this.informRequest}
                            showOperationLog={this.showOperationLog}
                            adjustPayUnit={this.adjustPayUnit}
                            applyAdjustment={this.applyAdjustment}
                            applyHistory={this.applyHistory}
                            recallInformRequest={this.recallInformRequest}
                            registerMilestoneDate={this.registerMilestoneDate}
                            registerRequestDate={this.registerRequestDate}
                        />
                    }
                    <UserDetail ref={el => this.userDetailRef = el} />
                    <OperationLog ref={el => this.operationLogRef = el} />
                    <LookAttachment ref={el => this.lookAttachmentRef = el}/>
                    <ExportModal ref={el => this.exportRef = el} searchParams={searchParams} />
                    <FoldSet ref={el => this.foldSetRef = el} loadData={this.loadHead} />
                    <SortList ref={el => this.sortListRef = el} loadData={this.loadHead} />
                    <MatchReturned ref={el => this.matchRef = el} loadData={this.loadData} />
                    <InformRequest ref={el => this.informRef = el} loadData={this.loadData} />
                    <AdjustPayUnit ref={el => this.adjustPayUnitRef = el} loadData={this.loadData} />
                    <ApplyAdjustment ref={el => this.applyAdjustmentRef = el} loadData={this.loadData} />
                    <UpdateReturnedProgress ref={el => this.returnedProgressRef = el} returnedProgressList={returnedProgressList} loadData={this.loadData} />
                    <ApplyHistory ref={el => this.applyHistoryRef = el} />
                    <Attachment ref={el => this.attachmentRef = el} />
                    <RegisterMilestoneDate
                        ref={el => this.milestoneDateRef = el}
                        systemDate={systemDate}
                        loadData={this.loadData}
                        informRequest={this.informRequest}
                    />
                    <RegisterRequestDate
                        ref={el => this.requestDateRef = el}
                        loadData={this.loadData}
                        dateModifyReason={dateModifyReason}
                    />
                    <Update
                        ref={el => this.updateRef = el}
                        loadData={this.loadData}
                        continueAdd={this.continueAdd}
                        listCollection={listCollection}
                        queryInvestigationStageByInvId={this.queryInvestigationStageByInvId}
                    />
                    <ConfigColumn ref={el => this.configColumnRef = el} headerType={headerType} loadData={this.loadHead} />
                </div>           
            </div>
        );
    }
}

const mapStateToProps = (state, props) => {
    return {
        params: state.noticeState.params,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        saveParams: (params) => dispatch(saveParams(params)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(RequestRecord);


// WEBPACK FOOTER //
// ./src/components/contractManagement/requestRecord/index.js